<template>
    <section>
        <!-- Basic Inputs start -->
        <Search />
        <!-- Basic Inputs end -->

        <!-- Hoverable rows start -->
        <Stores />
        <!-- Hoverable rows end -->

        <EditStore />
        <EditAfnParams />
        <EditStoreSupplierParams />
        <EditBrandCondition />
    </section>
</template>

<script>
    import Search from '@/views/store/Search'
    import Stores from '@/views/store/Stores'
    import EditStore from '@/views/store/EditStore'
    import EditAfnParams from '@/views/store/EditAfnParams'
    import EditStoreSupplierParams from '@/views/store/EditStoreSupplierParams'
    import EditBrandCondition from '@/views/store/EditBrandCondition.vue'

    export default {
        name: 'StoreHome',
        components: {
            Search, Stores, EditStore, EditAfnParams, EditStoreSupplierParams, EditBrandCondition,
        },
    }
</script>

<style scoped>

</style>
